class Accordion {
  root: HTMLElement
  toggle: HTMLElement | undefined | null
  content: HTMLElement | undefined | null

  constructor(root: HTMLElement) {
    this.root = root

    this.initialize()
  }

  initialize() {
    this.toggle = this.root.querySelector('[data-component="toggle"]') as HTMLElement
    this.content = this.root.querySelector('[data-component="content"]') as HTMLElement

    this.toggle.addEventListener('click', () => {
      if (this.isOpen()) {
        this.close()
      } else {
        this.open()
      }
    })

    // Find all previous and next accordion siblings and listen close this accordion, if any of them is opened
    let previousSibling = this.root.previousElementSibling
    while (previousSibling && previousSibling.matches('[data-component="accordion"]')) {
      previousSibling.addEventListener('accordion:beforeOpen', () => {
        this.close()
      })
      previousSibling = previousSibling.previousElementSibling
    }

    let nextSibling = this.root.nextElementSibling
    while (nextSibling && nextSibling.matches('[data-component="accordion"]')) {
      nextSibling.addEventListener('accordion:beforeOpen', () => {
        this.close()
      })
      nextSibling = nextSibling.nextElementSibling
    }

    window.addEventListener('resize', () => {
      if (this.isOpen() && this.content) {
        this.content.style.height = `${Math.ceil(this.content.scrollHeight)}px`
      }
    })
  }

  isOpen() {
    return this.root.classList.contains('is-open')
  }

  open() {
    if (this.content) {
      this.root.dispatchEvent(new Event('accordion:beforeOpen'))
      const height = this.content.scrollHeight
      this.root.classList.add('is-open')
      this.content.style.height = `${Math.ceil(height)}px`

      this.content.addEventListener('transitionend', () => {
        if (this.toggle) {
          if (
            this.toggle.offsetTop - 20 < window.scrollY
            || this.toggle.offsetTop + this.toggle.getBoundingClientRect().height > window.scrollY + window.innerHeight * 0.5
          ) {
            window.scrollTo({top: this.toggle.offsetTop - 20, behavior: 'smooth'})
          }
        }
      }, {once: true})
    }
  }

  close() {
    this.root.classList.remove('is-open')
    if (this.content) {
      this.content.style.height = ''
    }
  }
}

export { Accordion }
